module.exports = __webpack_public_path__ + "img/survey_02.57d71767.jpeg";